import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9dea280e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register" }
const _hoisted_2 = {
  key: 0,
  class: "left"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "left"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "right" }
const _hoisted_7 = {
  key: 1,
  class: "register-container"
}
const _hoisted_8 = {
  key: 2,
  class: "payment-container"
}
const _hoisted_9 = {
  key: 4,
  class: "notice"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "¿Tienes ya una cuenta con nosotros?", -1))
const _hoisted_11 = { class: "modal padding" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "message" }
const _hoisted_14 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackSteps = _resolveComponent("BackSteps")!
  const _component_SelectedSubscription = _resolveComponent("SelectedSubscription")!
  const _component_RegistrationForm = _resolveComponent("RegistrationForm")!
  const _component_PaymentForm = _resolveComponent("PaymentForm")!
  const _component_StepDone = _resolveComponent("StepDone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step === _ctx.Steps.Registration)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("img", {
            src: require('@/assets/images/pau-step1-background.png'),
            alt: "step1"
          }, null, 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === _ctx.Steps.Payment || _ctx.step === _ctx.Steps.Done)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: require('@/assets/images/pau-step2-background.png'),
            alt: "step1"
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_BackSteps, {
        elements: _ctx.elements,
        "selected-index": _ctx.selectedIndex,
        step: _ctx.step
      }, null, 8, ["elements", "selected-index", "step"]),
      (_ctx.selectedPlan && _ctx.step === _ctx.Steps.Payment)
        ? (_openBlock(), _createBlock(_component_SelectedSubscription, {
            key: 0,
            plan: _ctx.selectedPlan,
            discount: _ctx.discount,
            subscription: _ctx.selectedSubscription,
            discountName: _ctx.discountName,
            originalPriceMonth: _ctx.selectedSubscription.$priceMonth,
            priceMonth: _ctx.selectedSubscription.$farePricePerMonthCoupon
          }, null, 8, ["plan", "discount", "subscription", "discountName", "originalPriceMonth", "priceMonth"]))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.Steps.Registration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_RegistrationForm, { onClick: _ctx.createUser }, null, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.Steps.Payment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            (_ctx.selectedPlan && _ctx.selectedSubscription)
              ? (_openBlock(), _createBlock(_component_PaymentForm, {
                  key: 0,
                  selectedPlan: _ctx.selectedPlan,
                  selectedSubscription: _ctx.selectedSubscription,
                  appliedDiscount: _ctx.appliedDiscount,
                  discountError: _ctx.discountError,
                  discountCode: _ctx.discountCode,
                  discountAmount: _ctx.discountAmount,
                  error: _ctx.paymentError,
                  couponUsed: _ctx.couponUsed,
                  onApplyDiscount: _ctx.applyDiscount,
                  onPay: _ctx.pay,
                  onPromoPay: _ctx.promoPay
                }, null, 8, ["selectedPlan", "selectedSubscription", "appliedDiscount", "discountError", "discountCode", "discountAmount", "error", "couponUsed", "onApplyDiscount", "onPay", "onPromoPay"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.Steps.Done)
        ? (_openBlock(), _createBlock(_component_StepDone, {
            key: 3,
            class: "done-container"
          }))
        : _createCommentVNode("", true),
      (_ctx.step === _ctx.Steps.Registration)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_router_link, {
              to: { name: 'login', params: {
            subscriptionId: _ctx.$route.query.subscriptionId,
            planId: _ctx.$route.query.planId
          } }
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Inicia sesión ")
              ]),
              _: 1
            }, 8, ["to"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalComponent, {
      modelValue: _ctx.generalError.show,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.generalError.show) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_Modal, null, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.generalError.title), 1),
              _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.generalError.message), 1),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_Button, {
                  variant: "turquoise",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'login' })))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Ok")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}